import { useEffect } from "react";
import { LoginForm } from "../features/login-form/components/LoginForm";
import { Snackbar } from "../features/snackbar/components/Snackbar";
import { useSnackbar } from "../features/snackbar/context/SnackbarContext";
import { consumeLogoutNotification } from "../features/auth/session";

export const LoginPage = ({ setIsLoggedIn }) => {
  const { showSnackbarMessage } = useSnackbar();

  useEffect(() => {
    const logoutMessage = consumeLogoutNotification();

    if (logoutMessage) {
      showSnackbarMessage("success", logoutMessage);
    }
  }, [showSnackbarMessage]);

  return (
    <div className="app-container">
      {/* Background Image */}
      <img
        src={`${process.env.PUBLIC_URL}/background.jpeg`}
        alt="background"
        className="app-background"
      />

      {/* Overlay */}
      <div className="app-overlay"></div>

      <LoginForm setIsLoggedIn={setIsLoggedIn} />

      <Snackbar />
    </div>
  );
};